import { ArrowDownTrayIcon, XCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import ConfirmableButton from '../../../components/ConfirmableButton';
import LoadingSpinner from '../../../components/LoadingSpinner';

interface BookingCardActionsProps {
  onImport: () => Promise<void>;
  onReject: () => Promise<void>;
  isImporting: boolean;
  isRejecting: boolean;
  hasMissingCategories: boolean;
  isDisabled: boolean;
  showImportButton: boolean;
  showRejectButton: boolean;
  onShowImportButton: (show: boolean) => void;
  onShowRejectButton: (show: boolean) => void;
  onShowValidation: (show: boolean) => void;
  importButtonLabel?: string;
}

const BookingCardActions: React.FC<BookingCardActionsProps> = ({
  onImport,
  onReject,
  isImporting,
  isRejecting,
  hasMissingCategories,
  isDisabled,
  showImportButton,
  showRejectButton,
  onShowImportButton,
  onShowRejectButton,
  onShowValidation,
  importButtonLabel = 'Import',
}) => {
  return (
    <div className='flex gap-2 ml-4'>
      {showImportButton && (
        <ConfirmableButton
          onConfirm={onImport}
          buttonClassName='px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 text-xs font-medium flex items-center gap-1.5'
          containerClassName='flex gap-2'
          onShowConfirmation={show => {
            onShowRejectButton(!show);
            if (show && hasMissingCategories) {
              onShowValidation(true);
            }
          }}
          confirmationMessage={`Are you sure you want to ${importButtonLabel.toLowerCase()}?`}
          disabled={
            isImporting || isRejecting || hasMissingCategories || isDisabled
          }
        >
          {isImporting ? (
            <LoadingSpinner color='border-white' />
          ) : (
            <>
              <ArrowDownTrayIcon className='w-4 h-4' />
              {importButtonLabel}
            </>
          )}
        </ConfirmableButton>
      )}
      {showRejectButton && (
        <ConfirmableButton
          onConfirm={onReject}
          buttonClassName='px-3 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 text-xs font-medium flex items-center gap-1.5'
          containerClassName='flex gap-2'
          onShowConfirmation={show => onShowImportButton(!show)}
          confirmationMessage='Are you sure you want to reject?'
          disabled={
            isImporting || isRejecting || hasMissingCategories || isDisabled
          }
        >
          {isRejecting ? (
            <LoadingSpinner color='border-white' />
          ) : (
            <>
              <XCircleIcon className='w-4 h-4' />
              Reject
            </>
          )}
        </ConfirmableButton>
      )}
    </div>
  );
};

export default BookingCardActions;
